var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewProject = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 108,
    viewBox: "0 0 144 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 143.515,
    height: 107.636,
    fill: "#EDE9E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 21.125L105 31.4375L72 41.75L39 31.4375L72 21.125Z",
    fill: "#C5B9AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M72 21.125L105 31.4375L72 41.75L39 31.4375L72 21.125Z",
    fill: "#EDE9E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 31.4375L72 41.2344V86.0938L105 75.7812V31.4375Z",
    fill: "#C5B9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105 31.4375L72 41.2344V86.0938L105 75.7812V31.4375Z",
    fill: "#C5B9AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31.4375L72 41.2344V86.0938L39 75.7812V31.4375Z",
    fill: "#C5B9AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31.4375L72 41.2344V86.0938L39 75.7812V31.4375Z",
    fill: "#C5B9AC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 31.4375L72 41.2344V86.0938L39 75.7812V31.4375Z",
    fill: "#7B6469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 31.4375L72 41.2344V86.0938L39 75.7812V31.4375Z",
    fill: "#7B6469"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4107 66.9091L52.606 59.5123H48.5482C48.3176 59.5123 48.155 59.4289 48.0607 59.262C47.9663 59.0952 47.982 58.9191 48.1078 58.7337L55.0596 48H56.2549L55.0596 55.369H59.0544C59.2851 55.369 59.4529 55.4524 59.5577 55.6193C59.6626 55.7861 59.6626 55.9622 59.5577 56.1476L52.606 66.9091H51.4107Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 35.1436V42.2656L84.375 45.3594V37.8828L52.4062 27.3125L61.1719 24.5088L93.1406 35.1436Z",
    fill: "#4C4F5A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 35.1436V42.2656L84.375 45.3594V37.8828L52.4062 27.3125L93.1406 35.1436Z",
    fill: "#262529"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1719 67.0156L101.906 64.4375V67.5312L94.1719 70.1094V67.0156Z",
    fill: "#7B6469"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1719 71.1406L101.906 68.5625V71.6562L94.1719 74.2344V71.1406Z",
    fill: "#7B6469"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewProject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/New project.a842d1e8e63e05bfb183a90ac7900fbc.svg";